import classNames from 'classnames'
import './index.scss'

type ButtonProps = {
  variant?: 'primary' | 'outlined'
  size?: 'large' | 'medium' | 'small'
  children: React.ReactNode
  disabled?: boolean
  onClick?: () => void
  loading?: boolean
  icon?: React.ReactNode
}

export function Button({
  variant = 'primary',
  size = 'medium',
  children,
  disabled = false,
  onClick,
  loading = false,
  icon,
}: ButtonProps) {
  return (
    <button
      type="button"
      className={classNames('button', variant, size)}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? <span className="loader" /> : icon}
      <span>{children}</span>
    </button>
  )
}
